import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useMergeState from "../../../shared/hooks/useMergeState";
import { api } from "../../../shared/hooks/api";
import { AddOn } from "../../../data/entities";
import { error, success } from "../../../utils/toast";
import BackButton from "../../../shared/components/BackButton";
import Title from "./Title";
import { AddOnDetailWrapper } from "../detail/Styled";
import FormContainer from "../detail/FormContainer";

const initialData: Partial<AddOn> = {
    name: "",
    price: 0,
    quantity: 0,
};

const CreateAddOn = () => {
    const navigate = useNavigate();
    const [addOn, mergeAddOn] = useMergeState(initialData);
    const [validated, setValidated] = useState(false);
    const [{ isCreating }, createAddOn] = api.post("/addons/");

    const handleSubmit = () => {
        createAddOn(addOn)
            .then((resp: any) => {
                success("Thành Công", "Tạo mới dịch vụ thành công");
                navigate(`/addons/${resp.id}`);
            })
            .catch((err: any) => {
                error("Lỗi tạo mới dịch vụ", err);
            });
    };

    return (
        <AddOnDetailWrapper>
            <BackButton route="/addons/" label="Trở Về" />
            <Title
                title={"Thêm dịch vụ"}
                setValidated={setValidated}
                submitForm={handleSubmit}
                isLoading={isCreating}
            />
            <FormContainer
                validated={validated}
                addOn={addOn}
                mergeAddOn={mergeAddOn}
            />
        </AddOnDetailWrapper>
    );
};

export default CreateAddOn;
